module.exports = __webpack_public_path__ + "assets/hamburger.9b6ecb83.svg";